import BaseScene from '@Scenes/BaseScene';
import Config from '../../Config';
import * as Networks from '@Config/networks';
import * as Scenes from '@Config/scenes';
import EventEmitter from '@Utils/Events/EventEmitter';

/**
 * Main scene
 * @author charlie.bodman@kanoapps.com
 */
class DebugScene extends BaseScene
{
    private debugTextStr: string;

    private debugText: Phaser.GameObjects.Text;

    constructor()
    {
        super(Scenes.DEBUG);

        this.debugTextStr = 'Debug Enabled';

        EventEmitter.on('debug', 'log', this.logText)
    }

    public create()
    {
        this.addDebugText();
    }

    /**
     * Log text
     */
    private logText = (error: Error) =>
    {
        let message = '\n';

        if (error.hasOwnProperty('code'))
        {
            message += error['code'] + ' ';
        }

        if( error.message )
        {
            message += error.message;
        }

        this.debugTextStr += message;

        if (this.debugText)
        {
            this.debugText.setText(this.debugTextStr);
        }
    }

    /**
     * Add debug text
     */
    private async addDebugText()
    {
        this.debugText = this.add.text(0, 0, this.debugTextStr, { color: '#000000' });
    }
}

export default DebugScene;